const SRC_DCF = {
  //TOOD - Need to export as explicity constants
  EVENTS: {
    CLOSE_DCF_SHELL: 'src:dcf-shell:close',
    DCF_FETCHED_CONFIGS: 'src:dcf-shell:fetched-configs',
    DCF_FETCH_CONFIGS: 'src:dcf-shell:fetch-configs',
    DCF_GOTO_CARD_LIST: 'src:dcf-app:go-to-card-list',
    DCF_HANDSHAKE_ACCESS_TOKEN: 'src:dcf-app:new-access-token',
    DCF_PURCHASE_INTENT_FAILED: 'src:dcf-app:update-intent-fail',
    DCF_PURCHASE_INTENT_SUCCESS: 'src:dcf-app:update-intent-success',
    DCF_REQUEST_VBA_TOKEN: 'src:dcf-shell:request-vba-token',
    DCF_SEND_VBA_TOKEN: 'src:dcf-shell:send-vba-token',
    FETCH_RXO_MERCHANT_CONFIGS: 'getMerchantConfig',
    INIT_DCF_SHELL: 'src:dcf-shell:init',
    SET_DCF_CONFIG: 'src:dcf-configs:set',
    SET_RXO_MERCHANT_CONFIGS: 'setMerchantConfig'
  },
  IFRAME_ID: 'vcop-src-dcf-rframe',
  IFRAME_NAME: 'VCOP SRC DCF',
  IFRAME_WRAPPER_ID: 'vcop-src-dcf',
  PATH: '/checkout-widget/vcop/dcf'
};

export const DCF_SIGNOUT_USER = 'dcf:sign-out:change-user';
export const DCF_TIMEOUT_RESET = 'dcf:session-timeout:reset-app';

export default SRC_DCF;
